import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(public toastController: ToastController) {}

  async presentToast(message, duration, position) {
    const toast = await this.toastController.create({
      icon: 'information-circle',
      message: message,
      color: 'dark',
      duration: duration,
      position: position
    });
    toast.present();
  }


  toFixed(number, length) {
    return number.toFixed(length)
  }


  timeDifference(previous) {
    let d = new Date();
    let current = d.getTime();
    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;

    let p = new Date(previous)
    previous = p.getTime();

    var elapsed = current - previous;

    if (elapsed < msPerMinute) {
      return Math.round(elapsed / 1000) + ' secs';
    } else if (elapsed < msPerHour) {
      return Math.round(elapsed / msPerMinute) + ' mins';
    } else if (elapsed < msPerDay) {
      return Math.round(elapsed / msPerHour) + ' hrs';
    } else if (elapsed < msPerMonth) {
      return Math.round(elapsed / msPerDay) + ' days';
    } else if (elapsed < msPerYear) {
      return Math.round(elapsed / msPerMonth) + ' months';
    } else {
      return Math.round(elapsed / msPerYear) + ' years';
    }
  }
  
  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

}
